<script>
  import { Logo } from "$lib/components";
</script>

<footer class="mt-28">
  <!-- Top CTA Banner -->
  <div class="bg-white rounded-t-3xl border-t border-gray-100">
    <div class="container mx-auto px-6 md:px-11">
      <!-- CTA Section -->
      <div class="pt-16 pb-12 border-b border-gray-200">
        <div
          class="flex flex-col md:flex-row items-center justify-between gap-6"
        >
          <div>
            <h2
              class="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900"
            >
              Ready to grow your business?
            </h2>
            <p class="text-gray-500 mt-2 text-lg">
              Join hundreds of businesses already using UzaKitu.
            </p>
          </div>
          <div class="flex items-center gap-4 flex-shrink-0">
            <a
              href="/sign-up"
              class="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-3.5 rounded-full transition-all duration-200 shadow-lg shadow-green-500/20 hover:shadow-green-500/30"
            >
              Start Free Trial
              <svg
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </a>
            <a
              href="#pricing"
              class="inline-flex items-center gap-2 border-2 border-gray-200 hover:border-green-500 text-gray-700 hover:text-green-600 font-semibold px-8 py-3.5 rounded-full transition-all duration-200"
            >
              View Plans
            </a>
          </div>
        </div>
      </div>

      <!-- Footer Grid -->
      <div class="py-12 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-16">
        <!-- Brand Column -->
        <div class="col-span-2 md:col-span-1">
          <div class="mb-4">
            <Logo />
          </div>
          <p class="text-gray-500 text-sm leading-relaxed">
            Your all-in-one e-commerce platform. Manage products, track orders,
            and grow your business online.
          </p>
        </div>

        <!-- Product Column -->
        <div>
          <h3
            class="text-gray-900 font-semibold text-sm uppercase tracking-wider mb-4"
          >
            Product
          </h3>
          <ul class="space-y-3">
            <li>
              <a
                href="#pricing"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Pricing</a
              >
            </li>
            <li>
              <a
                href="/sign-up"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Sign Up</a
              >
            </li>
            <li>
              <a
                href="/login"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Login</a
              >
            </li>
            <li>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeSDVpw5ok9jzHCr2qBbEttWPaBSP0Mu7EUsM9xzB2JWNblGQ/viewform"
                target="_blank"
                rel="noopener noreferrer"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
              >
                Book a Demo
              </a>
            </li>
          </ul>
        </div>

        <!-- Company Column -->
        <div>
          <h3
            class="text-gray-900 font-semibold text-sm uppercase tracking-wider mb-4"
          >
            Company
          </h3>
          <ul class="space-y-3">
            <li>
              <a
                href="/contact"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Contact Us</a
              >
            </li>
            <li>
              <a
                href="/about"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >About</a
              >
            </li>
          </ul>
        </div>

        <!-- Legal Column -->
        <div>
          <h3
            class="text-gray-900 font-semibold text-sm uppercase tracking-wider mb-4"
          >
            Legal
          </h3>
          <ul class="space-y-3">
            <li>
              <a
                href="/terms-and-conditions"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Terms & Conditions</a
              >
            </li>
            <li>
              <a
                href="/privacy-policy"
                class="text-gray-500 hover:text-green-500 text-sm transition-colors"
                >Privacy Policy</a
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div
        class="py-6 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4"
      >
        <p class="text-gray-400 text-sm">
          © {new Date().getFullYear()} UzaKitu. All rights reserved.
        </p>

        <!-- Social Icons -->
        <div class="flex items-center gap-3">
          <a
            href="https://www.instagram.com/uzakitu_ke/"
            target="_blank"
            rel="noopener noreferrer"
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 flex items-center justify-center transition-all duration-200 group"
            aria-label="Instagram"
          >
            <svg
              class="w-4 h-4 text-gray-500 group-hover:text-white transition-colors"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
              />
            </svg>
          </a>
          <a
            href="https://twitter.com/uzakitu"
            target="_blank"
            rel="noopener noreferrer"
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-[#1DA1F2] flex items-center justify-center transition-all duration-200 group"
            aria-label="Twitter"
          >
            <svg
              class="w-4 h-4 text-gray-500 group-hover:text-white transition-colors"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
              />
            </svg>
          </a>
          <a
            href="https://ke.linkedin.com/company/uzakitu"
            target="_blank"
            rel="noopener noreferrer"
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-[#0A66C2] flex items-center justify-center transition-all duration-200 group"
            aria-label="LinkedIn"
          >
            <svg
              class="w-4 h-4 text-gray-500 group-hover:text-white transition-colors"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              />
            </svg>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61566760796708"
            target="_blank"
            rel="noopener noreferrer"
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-[#1877F2] flex items-center justify-center transition-all duration-200 group"
            aria-label="Facebook"
          >
            <svg
              class="w-4 h-4 text-gray-500 group-hover:text-white transition-colors"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </a>
          <a
            href="https://www.tiktok.com/@uzakitu"
            target="_blank"
            rel="noopener noreferrer"
            class="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-800 flex items-center justify-center transition-all duration-200 group"
            aria-label="TikTok"
          >
            <svg
              class="w-4 h-4 text-gray-500 group-hover:text-white transition-colors"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
